export default "__VITE_ASSET__vbvA9boY__"